import { getAPIURL } from "./config";

export const notificationsService = {
  getUnreadCount: async () => {
    try {
      const response = await fetch(`${getAPIURL()}notifications/unread/count`, {
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        error.status = response.status;
        throw error;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching unread notifications count:", error);
      throw error;
    }
  },

  getAllNotifications: async () => {
    try {
      const response = await fetch(`${getAPIURL()}notifications/all`, {
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching all notifications:", error);
      throw error;
    }
  },

  getUnreadNotifications: async () => {
    try {
      const response = await fetch(`${getAPIURL()}notifications/unread`, {
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        error.status = response.status;
        throw error;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching unread notifications:", error);
      throw error;
    }
  },

  registerToken: async (token) => {
    try {
      const response = await fetch(`${getAPIURL()}notifications/fcm/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ fcm_token: token }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error registering Firebase token:", error);
      throw error;
    }
  },

  markNotificationAsRead: async (notificationId) => {
    try {
      const response = await fetch(
        `${getAPIURL()}notifications/notifications/${notificationId}/mark-read`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.status === 204; // Возвращаем true если успешно
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  },
};
